import styled, { css } from 'styled-components';
import { transparentize } from 'polished';

export const AnimatedContainer = styled.div(
  ({ theme }) => css`
    @keyframes slideIn {
      from {
        margin-bottom: -${theme.sz.s28};
      }
      to {
        margin-bottom: 0;
      }
    }

    animation: slideIn 500ms;
  `,
);

export const FullHeightPortal = styled.div<{ $overlay?: boolean }>(
  ({ theme, $overlay }) => css`
    ${$overlay &&
    css`
      height: 100dvh;
      align-content: flex-end;
      background: ${transparentize(0.2, theme.co.secondary20)};
    `}
  `,
);
